/**
 * this pipe use to formating text
 * currently only to format Uppercase for first character in sentence or string
 */


import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'letter'
})
export class LetterPipe implements PipeTransform {

  transform(value: any): any {
    return value[0].toUpperCase() + value.substr(1).toLowerCase();
  }

}
